import { LeafLetMapOptions, LeafletMap, LeafletMapTiles } from "../modules";
import { AbstractComponent } from "./AbstractComponent";

export interface ModalMapProps extends LeafLetMapOptions {
  id: string;
}

export class ModalMap extends AbstractComponent<ModalMapProps> {
  private map: LeafletMap | null = null;
  public render(): void {
    const mapElement = document.getElementById(`map-${this.props.id}`);
    if (!mapElement) {
      throw new Error(`Map element with id "map-${this.props.id}" not found`);
    }
    this.map = LeafletMap.create(
      mapElement as HTMLDivElement,
      {
        center: this.props.center,
        zoom: this.props.zoom,
        tiles: this.props.tiles,
        markers: this.props.markers
      }
    );
    this.map.markers();
  }

  public invalidateSize(): void {
    if (this.map === null) {
      throw new Error("Map not initialized");
    }
    this.map.invalidateSize();
  }
  
  protected createContext(): void {
    
  }


  public static create(options: object, id: string) {
    const props: ModalMapProps = {
      ...this.optionsFrom(options),
      id
    };
    return new ModalMap(props);
  }

  private static optionsFrom(options: object): LeafLetMapOptions {
    const center = options["map-center"] 
      ? options["map-center"].split(',').map((coord) => parseFloat(coord))
      : [0, 0];
    const zoom = options["map-zoom"] ? parseInt(options["map-zoom"]) : 13;
    const tiles = options["map-tiles"] ? options["map-tiles"] : LeafletMapTiles.TONER;
    const markers = options["map-markers"] 
      ? options["map-markers"].map((marker) => ({
        ...marker,
        position: marker.position.split(',').map((coord) => parseFloat(coord))
      }))
      : [];
    return { 
      center: center as LeafLetMapOptions["center"], 
      zoom: zoom as LeafLetMapOptions["zoom"],
      tiles: tiles as LeafLetMapOptions["tiles"],
      markers: markers as LeafLetMapOptions["markers"]
    };
  }

}